import React from "react";
import { Link } from 'react-router-dom';
import { makeStyles, Theme } from "@material-ui/core/styles";
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import AddIcon from '@material-ui/icons/Add';
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Avatar from '@material-ui/core/Avatar';
import AccountCircle from "@material-ui/icons/AccountCircle";
import { auth, db } from "../settings/firebase";
import AuthCheck from "./Authentication/Check";
import getQueryStrings from "../utils/getQueryStrings";

// CSSスタイル
const barStyle = makeStyles((Theme) => ({
  bottomBar: {
    display: 'flex',
    width: '100%',
    height: '75px',
    position: 'fixed',
    bottom: 0,
    borderTop: 'solid 1px #deded9',
    textAlign: 'justify',
    textJustify: 'inter-ideograph',
  },
  barGrow: {
    flexGrow: "1"
  },
  barSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  /* Icon */
  iconCircle: {
    width: "44px",
    height: "44px",
    alignItems: "center",
    justifyContent: "center",
    color: "#555046",
  },
  postIconCircle: {
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    backgroundColor: Theme.palette.primary.main,
    color: "#ffffff",
  },
  postIconCircleLarge: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    backgroundColor: Theme.palette.primary.main,
    boxShadow: "0 10px 25px 0 rgba(0, 0, 0, .5)",
    color: "#555555",
  },
  accountCircle: {
    width: "44px",
    height: "44px",
    alignItems: "center",
    justifyContent: "center",
  },
  appsignup: {
    height: "42px",
    width: "116px",
    alignItems: "center",
    // フォント
    textAlign: "center",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "18px",
    lineHeight: "250%",
    /* identical to box height, or 64px */
    color: "#ffffff",
    border: "3px solid",
    borderRadius: "13px",
    boxShadow: "0 3px 3px 0 rgba(0, 0, 0, .5)",
    /* ホバー時 */
    "&:hover": {
      background: Theme.palette.primary.dark,
      boxShadow: "0 1px 1px 0 rgba(0, 0, 0, .5)",
    },
  },
  appsignupbtn: {
    width: "116px",
    height: "48px",
    marginLeft: "7px",
    marginRight: "15px",
    /* post_Icon_color */
    background: "#ffffff",
    borderRadius: "13px",
    boxShadow: "0 3px 3px 0 rgba(0, 0, 0, .5)",
    /* 投稿する テキスト*/
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    textDecoration: "none",

    /*フォントはboldで違和感がなければ特に指定はしません*/
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "18px",
    lineHeight: "176.69%",
    /* identical to box height, or 32px */
    color: Theme.palette.primary.dark,
    /* ホバー時 */
    "&:hover": {
      background: Theme.palette.secondary.main,
      boxShadow: "0 1px 1px 0 rgba(0, 0, 0, .5)",
    },
  },
  bottompopupDiv: {
    display: 'flex',
    marginLeft: "15px",
  },
  bottompopup: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '0',
    width: '100%',
    height: '115px',
    position: 'fixed',
    bottom: 0,
    borderTop: 'solid 1px #deded9',
    backgroundColor: Theme.palette.primary.main,
    textAlign: 'justify',
  },
  bottomSignout: {
    display: 'flex',
    width: 'calc(100vw - 17px)',
    height: '60px',
    position: 'fixed',
    bottom: 0,
    borderTop: 'solid 1px #deded9',
    backgroundColor: Theme.palette.primary.main,
    textAlign: 'justify',
  },
  bottompopuptext: {
    color: '#ffffff',
    marginTop: "0",
    fontWeight: "600",
    marginLeft: '25px',
    textShadow: '1px 0 0 #aaa, 0 1px 0 #aaa, -1px 0 0 #aaa, 0 -1px 0 #aaa',
  }
}));

class UserAccountCircle extends React.Component {
  constructor(props){
    super(props);
    this.state = { name: "", avatarUrl: "" };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }

  _isMounted = false;

  componentDidMount() {
    const user = auth.currentUser;
    if (user !== null) {
      this.setState({name: user.displayName, avatarUrl: user.photoURL});
    }
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    if(this.state.avatarUrl !== "") {
      return (
        <Avatar alt={this.state.name} src={this.state.avatarUrl} style={{height:"40px", width:"40px"}} />
      )
    } else {
      return (
        <AccountCircle style={{height:"40px", width:"40px", color:"#555046"}}/>
      )
    }
  }
}

// 現在のパスをパラメタにセットする
function nowlocation() {
  const redirect = getQueryStrings(window.location.search)["redirect"];
  if (redirect && redirect !== "/") {
    return "?redirect=" + encodeURIComponent(redirect);
  } else if (["/", "/signin", "/signup", "/signout"].indexOf(window.location.pathname) === -1) {
    return "?redirect=" + encodeURIComponent(window.location.pathname);
  }
  return "";
}

function Footer(props) {
  let thispage = "";
  if (props.page !== null) {
    thispage = props.page;
  }
  const [location, setLocation] = React.useState(thispage);

  const handleChange = (e, newValue) => {
    setLocation(newValue);
  }

  // ユーザマイページに遷移する
  const handleDisplayUserPage = async () => {
    const user = auth.currentUser;
    if (user !== null) {
      db.collection("users").doc(user.uid).get().then(doc => {
        return window.location.href = "/" + doc.data().displayid;
      }).catch(error => {
        return;
      })
    } else {
      return;
    }
  };

  const classes = barStyle();
  return (
    <>
      <AuthCheck>
        <BottomNavigation value={location} onChange={handleChange} className={classes.bottomBar}>
          <BottomNavigationAction label="ホーム" value="home" component={Link} to="/" icon={<HomeIcon className={classes.iconCircle} />} />
          <BottomNavigationAction label="投稿する" value="post" component={Link} to="/post" icon={
            <AddIcon className={location === "post"? classes.postIconCircle : classes.postIconCircleLarge} />
          } />
          <BottomNavigationAction label="マイページ" value="mypage" onClick={handleDisplayUserPage} icon={
            <UserAccountCircle className={classes.accountCircle} />
          } />
        </BottomNavigation>
      </AuthCheck>
      <AuthCheck signout>
        <BottomNavigation className={classes.bottompopup}>
          <Typography variant="h3" style={{fontSize: "20px"}} className={classes.bottompopuptext}>SelectBook登録をおすすめします</Typography>
          <Typography variant="p" className={classes.bottompopuptext} style={{fontSize: "14px"}}>SelectBookを登録しておくとすべての機能を利用できます</Typography>
          <div className={classes.bottompopupDiv}>
            <div className={classes.barGrow} />
            <div className={classes.barSection}>
              <Button href={"/signin" + nowlocation()}>
                <Typography className={classes.appsignup} variant="h1" noWrap>ログイン</Typography>
              </Button>
              <Button className={classes.appsignupbtn} href={"/signup" + nowlocation()}>
                無料登録
              </Button>
            </div>
          </div>
        </BottomNavigation>
      </AuthCheck>
    </>
  );
}

export default Footer;